export default __webpack_public_path__ + "static/media/photo-add.0236c80f.jpg";